services.factory('Init', [
    '$state', '$ionicLoading', '$ionicHistory', '$rootScope', 'config', 'constants', 'ErrorService',
    'API', 'LoginService', 'LocaleService', 'LocalStorage', 'Storage', 'UserService',
    'AccountService', 'ProChartService', 'CountryService', '$q', 'SocialAuthService', 'Utils', '$cookies', 'moment', 'Onesignal', 'IntercomService',
    function ($state, $ionicLoading, $ionicHistory, $rootScope,
              config, Const, ErrorService, API, LoginService, LocaleService, LocalStorage, Storage, UserService,
              AccountService, ProChartService, CountryService, $q, SocialAuthService, Utils, $cookies, moment, Onesignal, IntercomService) {

        var self = this;
        var defaultReturnState = 'root.app.assets';

        self.isInitialized = false;
        self.returnStateAfterDisconnect = defaultReturnState;

        function handleConnect() {
            log('handle connect');
            API.platform({platform: Const.platformById.webMobile});

            //initialize third-party auth providers
            SocialAuthService.init()

            Onesignal.init();

            IntercomService.init();

            return loadSettings()
                .then(function() {
                    // save asset deeplink in ls
                    var assetParam = Utils.getURLParameterByName('asset');
                    if (assetParam) {
                        LocalStorage.save('link', JSON.stringify({name: 'asset', params: assetParam}));
                    }
                })
                .then(CountryService.init)
                .then(LoginService.loginToken)
                .then(LoginService.initServices)
                .then(function () {
                    self.isInitialized = true;
                    $ionicLoading.hide();
                })
                .then(saveRemarketing)
                .then(function () {
                    Onesignal.setTag("platform", Const.platformById.webMobile)
                })

        }

        function handleDisconnect() {
            log('handle disconnect');
            self.isInitialized = false;
            $ionicHistory.clearHistory();
            $rootScope.loadingMessage = LocaleService.translation.connection || LocaleService.messages.connection;
            $ionicLoading.show({
                templateUrl: 'templates/directives/message-spinner.html',
                scope: $rootScope
            });

            LoginService
                .clearServices()
                // .then(function () {
                //     $state.go('welcome', {cache: false});
                // })
                .then(function () {
                    throw new ErrorService({
                        source: 'API',
                        type: Const.error.type.NETWORK,
                        severity: 'warning',
                        code: 'socketDisconnected'
                    });
                });


        }

        function loadSettings() {
            return Storage.load('brandConfiguration', true)
                .then(function () {
                    return Storage.load(['countries', 'currencies', 'geo', 'withdrawalReasons'])
                })
        }

        function saveRemarketing() {
            var remarketingString = Utils.getUrlRemarketing(),
                cookieRemarketing = $cookies.get('remarketing');
            if (remarketingString && !cookieRemarketing) {
                var exp = moment().add(30, 'day').calendar()
                $cookies.put('remarketing', remarketingString, {'path': '/', 'expires': exp});
            }
        }

        this.run = function () {
            console.log('Init run()');

            if (!self.isInitialized) {
                const endpoint = Utils.getURLParameterByName('endpoint');
                if (endpoint) {
                    API.setSocketUrl(endpoint);
                }

                return LocaleService
                    .load()
                    .then(API.connect)
                    .then(handleConnect)
            } else {
                console.log("Already initialized.");
                return $q.resolve()
            }
        };

        this.setInitialzied = function (value) {
            self.isInitialized = value
        };

        this.updateInitializedStatus = function () {
            self.isInitialized = UserService.get().loggedIn && API.getSocket().getInstance().connected
        };

        // API.onConnect(handleConnect);

        API.onReconnect(function () {
            log('onReconnect handler.');

            LocaleService
                .load()
                .then(loadSettings)
                .then(CountryService.init)
                .then(LoginService.loginToken)
                .then(LoginService.initServices)
                .then(function () {
                    self.isInitialized = true;
                    $ionicLoading.hide();
                    $rootScope.$emit('reconnect');
                    return $state.go('root.app.assets');
                    // $state.go(self.returnStateAfterDisconnect, {cache: false}, {reload: true});
                })
                .catch(function (err) {
                    log('onReconnect error: ', err);
                    self.isInitialized = false;
                    $ionicLoading.hide();
                    return $state.go('welcome', {cache: false}, {reload: true})
                })
        });

        API.onDisconnect(handleDisconnect);

        /*API.onReconnectAttempt(function (attemptNumber) {
           console.log("reconnect attempt: ", attemptNumber);
            var maxReconnectAttempts = 5;
            if (attemptNumber > maxReconnectAttempts) {
                $ionicLoading.hide();
                $state.go('root.welcome')
            }
        });*/

        return this;
    }]);
